import { createRoot } from "react-dom/client";
import Winners from "../app/(general-header)/winners/page";
import { StoreProvider } from "../app/storeProvider";
import React from "react";

const root = createRoot(document.getElementById("winners-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <Winners />
    </StoreProvider>
  </React.StrictMode>
);
